import throttle from 'lodash/throttle';
import { theme } from '@root/tailwind.config.js';

(() => {
	const header =  document.querySelector('.header');
	const mainmenu = document.querySelector('.mainmenu');
	const stickyMenuEl = document.querySelector('.stickymenu');
	const screenMd = Number.parseInt(theme.screens.md.replace('px', ''));

	if(stickyMenuEl && header && mainmenu) {
		const showAfter = header.clientHeight + mainmenu.clientHeight;
		const toggleStickyMenu = () => {
			let scrollProgress = window.pageYOffset || document.documentElement.scrollTop;

			// IF the screen is smaller than 768px - show
			if (window.innerWidth < screenMd) {
				if (scrollProgress > showAfter) {
					stickyMenuEl.classList.add('stickymenu--isvisible');
				} else {
					stickyMenuEl.classList.remove('stickymenu--isvisible');
				}
			}
			else {
				if (scrollProgress > showAfter) {
					stickyMenuEl.classList.add('stickymenu--isvisible');
				} else {
					stickyMenuEl.classList.remove('stickymenu--isvisible');
				}
			}
		};

		toggleStickyMenu();
		
		window.addEventListener('scroll', throttle(toggleStickyMenu, 100));
	}
})();
